
import Music from "../../../assets/duotone/Music.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MusicIcon({ className, dataTestid = "MusicIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Music data-testid={dataTestid} className={classes} {...rest} />
  );
}
